.container {
  display: flex;
  flex-direction: column;
}

.inputRow {
  display: flex;
  align-items: center;
  height: var(--toolbar-height);
  padding: 0 0.5rem;
}

.input {
  flex: 1;
  height: var(--toolbarBtn-height);
  padding: 0 0.5rem;
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 0 2px dimgray;
  outline: none;
}

.input:hover,
.input:focus {
  box-shadow: 0 0 2px 1px dimgray;
}

.entries {
  list-style: none;
  margin: 0;
  padding: 0;
  text-overflow: ellipsis;
}

.entries button {
  padding-left: 1rem;
}
